import { Reveal } from "./Section";

const Quotes = () => (
  <section className="relative py-28 md:py-40 bg-[#0C0F16] overflow-hidden" data-testid="quotes-section">
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <span className="font-display text-[26rem] leading-none text-outline opacity-[0.06] select-none">”</span>
    </div>
    <div className="relative mx-auto max-w-5xl px-5 md:px-8 text-center">
      <Reveal>
        <p className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.25] text-slate-100" data-testid="quote-primary">
          “I don't want to simply build companies. I want to build things that <span className="italic gold-text">remain useful</span> long after I am gone.”
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
          <span>Build with purpose</span><span className="text-[#E2C08D]">·</span>
          <span>Connect with people</span><span className="text-[#E2C08D]">·</span>
          <span>Create with courage</span><span className="text-[#E2C08D]">·</span>
          <span>Leave something meaningful behind</span>
        </div>
      </Reveal>
      <Reveal delay={0.25}>
        <p className="mt-16 font-display italic text-xl md:text-2xl text-slate-400" data-testid="quote-secondary">
          “A transaction can create value once. A meaningful relationship can create value for generations.”
        </p>
      </Reveal>
    </div>
  </section>
);

export default Quotes;
